module.exports = __webpack_public_path__ + "static/media/kali_raspberry.a809f5e7.png";